import { DateTime } from 'luxon';

export interface ICountry {
    id?: number;
    created_at: string;
    updated_at: string;
    name: string;
    region_code: string;
    country_code: string;
}

export default class Country {
    id = 0;
    created_at: DateTime = DateTime.now();
    updated_at: DateTime = DateTime.now();
    name = '';
    region_code = '';
    country_code = '';

    toJSON(): ICountry {
        //console.debug("Country.toJSON()", this);
        return Object.assign({} as ICountry, this, {
            created_at: undefined,
            updated_at: undefined,
        });
    }

    static fromJSON(json: ICountry): Country {
        //console.debug("Country.fromJSON()", json);
        const user = Object.create(Country.prototype);
        return Object.assign(user, json, {
            created_at: json.created_at ? DateTime.fromISO(json.created_at) : DateTime.now(),
            updated_at: json.updated_at ? DateTime.fromISO(json.updated_at) : DateTime.now(),
        });
    }
}
